import { render, staticRenderFns } from "./newsDisplay.vue?vue&type=template&id=bb431bf6&lang=pug"
import script from "./newsDisplay.vue?vue&type=script&lang=js"
export * from "./newsDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports